interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  accent?: "primary" | "accent" | "secondary";
}

const accentMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function SectionHeading({ eyebrow, title, desc, accent = "primary" }: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${accentMap[accent]}`}
      >
        <i className="ri-bookmark-3-line" />
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}